'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deleteInputDB = exports.deleteInputUI = exports.deleteInputReal = exports.saveConfiguration = exports.getConfiguration = exports.soapVersion = exports.webMethod = exports.updateInputValue = exports.updateInputName = exports.updateInput = exports.createInput = exports.wsdlSuccess = exports.wsdlInvalidError = exports.wsdlParseError = exports.wsdlReadError = exports.wsdlLoading = exports.deleteQuotesOnSendValue = exports.togglePushQuotes = exports.setSendCommand = exports.toggleCached = exports.toggleSendCommand = exports.toggleSendEmail = exports.toggleDeleteSelected = exports.toggleDeleteAll = exports.toggleDeleteQuotesOnSend = exports.deleteQuotesOnSendActive = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends7 = require('babel-runtime/helpers/extends');

var _extends8 = _interopRequireDefault(_extends7);

exports.default = oldCFAReducer;
exports.saveConfigurationSaga = saveConfigurationSaga;
exports.watchSaveConfiguration = watchSaveConfiguration;
exports.oldCFAwatchers = oldCFAwatchers;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _api = require('helpers/api');

var _api2 = _interopRequireDefault(_api);

var _fetchEntitySagaAuth = require('../../utils/fetchEntitySagaAuth');

var _fetchEntitySagaAuth2 = _interopRequireDefault(_fetchEntitySagaAuth);

var _notifications = require('../notifications');

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(saveConfigurationSaga),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(deleteInputSaga),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(deleteInputDBSaga),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(watchSaveConfiguration),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(oldCFAwatchers);

var uuidV4 = _uuid2.default.v4;

/* constants */
var ACTIVE = 'tq-plus-admin/genericSettings/oldCFA/active';
var TOGGLE_DELETE_ON_SEND = 'tq-plus-admin/genericSettings/oldCFA/toggle_delete_on_send';
var TOGGLE_DELETE_ALL = 'tq-plus-admin/genericSettings/oldCFA/TOGGLE_DELETE_ALL';
var TOGGLE_DELETE_SELECTED = 'tq-plus-admin/genericSettings/oldCFA/TOGGLE_DELETE_SELECTED';
var TOGGLE_SEND_EMAIL = 'tq-plus-admin/genericSettings/oldCFA/toggle_send_email';
var TOGGLE_SEND_COMMAND = 'tq-plus-admin/genericSettings/oldCFA/toggle_send_command';
var TOGGLE_CACHED = 'tq-plus-admin/genericSettings/oldCFA/TOGGLE_CACHED';
var SET_SEND_COMMAND = 'tq-plus-admin/genericSettings/oldCFA/set_send_command';
var TOGGLE_PUSH_QUOTES = 'tq-plus-admin/genericSettings/oldCFA/toggle_push_quotes';
var VALUE = 'tq-plus-admin/genericSettings/oldCFA/value';
var WSDL_LOADING = 'tq-plus-admin/genericSettings/oldCFA/wsdl_loading';
var WSDL_READ_ERROR = 'tq-plus-admin/genericSettings/oldCFA/wsdl_read_error';
var WSDL_PARSE_ERROR = 'tq-plus-admin/genericSettings/oldCFA/wsdl_parse_error';
var WSDL_INVALID_ERROR = 'tq-plus-admin/genericSettings/oldCFA/wsdl_invalid_error';
var WSDL_SUCCESS = 'tq-plus-admin/genericSettings/oldCFA/wsdl_success';
var CREATE_INPUT = 'tq-plus-admin/genericSettings/oldCFA/create_input';
var UPDATE_INPUT = 'tq-plus-admin/genericSettings/oldCFA/update_input';
var UPDATE_INPUT_NAME = 'tq-plus-admin/genericSettings/oldCFA/update_input_name';
var UPDATE_INPUT_VALUE = 'tq-plus-admin/genericSettings/oldCFA/update_input_value';
var CREATE_OUTPUT = 'tq-plus-admin/genericSettings/oldCFA/create_output';
var DELETE_OUTPUT = 'tq-plus-admin/genericSettings/oldCFA/delete_output';
var WEB_METHOD = 'tq-plus-admin/genericSettings/oldCFA/WEB_METHOD';
var SOAP_VERSION = 'tq-plus-admin/genericSettings/oldCFA/SOAP_VERSION';

var GET_CONFIGURATION = {
    BASE: 'tq-plus-admin/genericSettings/oldCFA/GET_CONFIGURATION.BASE',
    REQUEST: 'tq-plus-admin/genericSettings/oldCFA/GET_CONFIGURATION.REQUEST',
    SUCCESS: 'tq-plus-admin/genericSettings/oldCFA/GET_CONFIGURATION.SUCCESS',
    FAILURE: 'tq-plus-admin/genericSettings/oldCFA/GET_CONFIGURATION.FAILURE'
};

var SAVE_CONFIGURATION = {
    BASE: 'tq-plus-admin/genericSettings/oldCFA/SAVE_CONFIGURATION.BASE',
    REQUEST: 'tq-plus-admin/genericSettings/oldCFA/SAVE_CONFIGURATION.REQUEST',
    SUCCESS: 'tq-plus-admin/genericSettings/oldCFA/SAVE_CONFIGURATION.SUCCESS',
    FAILURE: 'tq-plus-admin/genericSettings/oldCFA/SAVE_CONFIGURATION.FAILURE'
};

var DELETE_INPUT = {
    BASE: 'tq-plus-admin/genericSettings/oldCFA/DELETE_INPUT.BASE',
    REQUEST: 'tq-plus-admin/genericSettings/oldCFA/DELETE_INPUT.REQUEST',
    SUCCESS: 'tq-plus-admin/genericSettings/oldCFA/DELETE_INPUT.SUCCESS',
    FAILURE: 'tq-plus-admin/genericSettings/oldCFA/DELETE_INPUT.FAILURE'
};

var DELETE_INPUT_UI = 'tq-plus-admin/genericSettings/oldCFA/DELETE_INPUT_UI';
var DELETE_INPUT_REAL = 'tq-plus-admin/genericSettings/oldCFA/DELETE_INPUT_REAL';

/* reducer */
var initialState = {
    deleteQuotesOnSend: {
        active: false, // rename to selected
        value: 'A'
    },
    deleteAllQuotes: false,
    deleteSelectedQuotes: false,
    sendEmail: false,
    sendCommand: {
        selected: false,
        value: ''
    },
    pushRefNum: {
        selected: false,
        wsdlFile: {
            read: false, // from file
            readFromDB: false,
            contents: null,
            data: {
                url: null,
                webMethods: null,
                namespace: null,
                soapNamespace: 'http://schemas.xmlsoap.org/soap/envelope/',
                xmlRequestMainNode: null,
                xmlRequestNamespace: null
            },
            id: null,
            cached: false,
            error: null,
            errorDB: null,
            webMethod: null,
            soapVersions: ['Version 1.1', 'Version 1.2', 'Custom'],
            selectedSoapVersion: 'Version 1.1',
            replicationServiceId: 0
        }
    },
    inputs: {},
    outputs: {}
};

function oldCFAReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case ACTIVE:
            return (0, _extends8.default)({}, state, {
                deleteQuotesOnSend: (0, _extends8.default)({}, state.deleteQuotesOnSend, {
                    active: action.payload.active
                })
            });

        case TOGGLE_DELETE_ON_SEND:
            return (0, _extends8.default)({}, state, {
                deleteQuotesOnSend: (0, _extends8.default)({}, state.deleteQuotesOnSend, {
                    active: !state.deleteQuotesOnSend.active
                })
            });

        case TOGGLE_DELETE_ALL:
            return (0, _extends8.default)({}, state, {
                deleteAllQuotes: !state.deleteAllQuotes
            });

        case TOGGLE_DELETE_SELECTED:
            return (0, _extends8.default)({}, state, {
                deleteSelectedQuotes: !state.deleteSelectedQuotes
            });

        case TOGGLE_SEND_EMAIL:
            return (0, _extends8.default)({}, state, {
                sendEmail: (0, _extends8.default)({}, state.sendEmail, {
                    selected: !state.sendEmail.selected
                })
            });

        case TOGGLE_SEND_COMMAND:
            return (0, _extends8.default)({}, state, {
                sendCommand: (0, _extends8.default)({}, state.sendCommand, {
                    selected: !state.sendCommand.selected
                })
            });

        case TOGGLE_CACHED:
            {
                var nextCached = !state.pushRefNum.wsdlFile.cached;
                var _nextState = (0, _extends8.default)({}, state);
                _nextState.pushRefNum.wsdlFile.cached = nextCached;
                return _nextState;
            }

        case SET_SEND_COMMAND:
            return (0, _extends8.default)({}, state, {
                sendCommand: (0, _extends8.default)({}, state.sendCommand, {
                    value: action.payload
                })
            });

        case TOGGLE_PUSH_QUOTES:
            return (0, _extends8.default)({}, state, {
                pushRefNum: (0, _extends8.default)({}, state.pushRefNum, {
                    selected: !state.pushRefNum.selected
                })
            });

        case VALUE:
            return (0, _extends8.default)({}, state, {
                deleteQuotesOnSend: (0, _extends8.default)({}, state.deleteQuotesOnSend, {
                    value: action.payload
                })
            });

        case WSDL_SUCCESS:
            {
                var nextId = state.pushRefNum.wsdlFile.id === -1 ? 0 : state.pushRefNum.wsdlFile.id;
                return (0, _extends8.default)({}, state, {
                    pushRefNum: (0, _extends8.default)({}, state.pushRefNum, {
                        wsdlFile: (0, _extends8.default)({}, state.pushRefNum.wsdlFile, {
                            data: (0, _extends8.default)({}, state.pushRefNum.wsdlFile.data, action.payload),
                            read: true,
                            error: null,
                            webMethod: action.payload.webMethods[0],
                            id: nextId
                        })
                    })
                });
            }

        case WSDL_READ_ERROR:
        case WSDL_PARSE_ERROR:
        case WSDL_INVALID_ERROR:
            return (0, _extends8.default)({}, state, {
                pushRefNum: (0, _extends8.default)({}, state.pushRefNum, {
                    wsdlFile: (0, _extends8.default)({}, state.pushRefNum.wsdlFile, {
                        error: action.payload
                    })
                })
            });

        case CREATE_INPUT:
            return (0, _extends8.default)({}, state, {
                inputs: (0, _extends8.default)({}, state.inputs, (0, _defineProperty3.default)({}, uuidV4(), { name: '', value: '', id: '0', pendingServerDeletion: false }))
            });

        case DELETE_INPUT.BASE:
            {
                var id = action.id;
                return (0, _extends8.default)({}, state, {
                    inputs: (0, _extends8.default)({}, state.inputs, (0, _defineProperty3.default)({}, id, (0, _extends8.default)({}, state.inputs[id], {
                        pendingServerDeletion: true
                    })))
                });
            }

        case DELETE_INPUT.FAILURE:
            {
                var _nextInputs = (0, _extends8.default)({}, state.inputs);
                (0, _keys2.default)(_nextInputs).forEach(function (id) {
                    _nextInputs[id].pendingServerDeletion = false;
                });
                return (0, _extends8.default)({}, state, {
                    inputs: _nextInputs
                });
            }

        // case DELETE_INPUT_UI: {
        //   return state
        // }

        case DELETE_INPUT_REAL:
            {
                var filteredIds = (0, _keys2.default)(state.inputs).filter(function (id) {
                    return id !== action.payload;
                });
                var filteredInputs = {};
                filteredIds.forEach(function (id) {
                    return filteredInputs[id] = state.inputs[id];
                });
                return (0, _extends8.default)({}, state, {
                    inputs: filteredInputs
                });
            }

        case UPDATE_INPUT:
            return (0, _extends8.default)({}, state, {
                inputs: (0, _extends8.default)({}, state.inputs, (0, _defineProperty3.default)({}, action.payload.id, (0, _extends8.default)({}, action.payload)))
            });

        case UPDATE_INPUT_NAME:
            return (0, _extends8.default)({}, state, {
                inputs: (0, _extends8.default)({}, state.inputs, (0, _defineProperty3.default)({}, action.payload.id, (0, _extends8.default)({}, state.inputs[action.payload.id], {
                    name: action.payload.name
                })))
            });
        case UPDATE_INPUT_VALUE:
            return (0, _extends8.default)({}, state, {
                inputs: (0, _extends8.default)({}, state.inputs, (0, _defineProperty3.default)({}, action.payload.id, (0, _extends8.default)({}, state.inputs[action.payload.id], {
                    value: action.payload.value
                })))
            });

        case CREATE_OUTPUT:
            return (0, _extends8.default)({}, state, {
                outputs: [].concat((0, _toConsumableArray3.default)(state.outputs), [(0, _extends8.default)({}, action.payload, { id: i++ })])
            });

        case DELETE_OUTPUT:
            return (0, _extends8.default)({}, state, {
                outputs: state.outputs.filter(function (output) {
                    return output.id !== action.payload;
                })
            });

        case WEB_METHOD:
            return (0, _extends8.default)({}, state, {
                pushRefNum: (0, _extends8.default)({}, state.pushRefNum, {
                    wsdlFile: (0, _extends8.default)({}, state.pushRefNum.wsdlFile, {
                        webMethod: action.payload
                    })
                })
            });

        case SOAP_VERSION:
            return (0, _extends8.default)({}, state, {
                pushRefNum: (0, _extends8.default)({}, state.pushRefNum, {
                    wsdlFile: (0, _extends8.default)({}, state.pushRefNum.wsdlFile, {
                        selectedSoapVersion: action.payload
                    })
                })
            });

        case GET_CONFIGURATION.REQUEST:
            {
                return state;
            }

        case GET_CONFIGURATION.SUCCESS:
            {
                var data = action.payload;

                if (data.wsdlConnection.Id === -1) {
                    return (0, _extends8.default)({}, state, {
                        pushRefNum: (0, _extends8.default)({}, state.pushRefNum, {
                            wsdlFile: (0, _extends8.default)({}, state.pushRefNum.wsdlFile, {
                                errorDB: false,
                                id: data.wsdlConnection.Id,
                                readFromDB: true
                            })
                        })
                    });
                }

                var nextData = (0, _extends8.default)({}, state.pushRefNum.wsdlFile.data, {
                    namespace: data.wsdlConnection.Namespace || null,
                    soapNamespace: data.wsdlConnection.SOAPNamespace || 'http://schemas.xmlsoap.org/soap/envelope/',
                    url: data.wsdlConnection.WebServiceURL || null,
                    webMethods: data.wsdlConnection.WebMethods || null, // not going to be sent from server for time being
                    xmlRequestMainNode: data.wsdlConnection.RequestObjectName || null,
                    xmlRequestNamespace: data.wsdlConnection.RequestObjectNamespace || null
                });

                var _nextCached = data.wsdlConnection.Cached || false;

                var nextWsdlFile = (0, _extends8.default)({}, state.pushRefNum.wsdlFile, {
                    cached: _nextCached,
                    data: nextData,
                    error: false,
                    errorDB: false,
                    id: data.wsdlConnection.Id || 0,
                    readFromDB: true,
                    replicationServiceId: data.wsdlConnection.ReplicationServiceId,
                    webMethod: data.wsdlConnection.WebMethod
                });

                var nextPushRefNum = (0, _extends8.default)({}, state.pushRefNum, {
                    wsdlFile: nextWsdlFile
                });

                var _nextInputs2 = {};
                data.inputParameters.forEach(function (inputParameter) {
                    _nextInputs2[uuidV4()] = {
                        id: inputParameter.Id,
                        name: inputParameter.ParameterName,
                        value: inputParameter.ParameterValue,
                        pendingServerDeletion: false
                    };
                });

                var _nextState2 = (0, _extends8.default)({}, state, {
                    pushRefNum: nextPushRefNum,
                    inputs: _nextInputs2
                });
                return _nextState2;
            }

        case GET_CONFIGURATION.FAILURE:
            {
                console.log('Reducer: GET_CONFIGURATION.FAILURE');
                return state;
            }

        case SAVE_CONFIGURATION.REQUEST:
            {
                return state;
            }

        case SAVE_CONFIGURATION.SUCCESS:
            var nextInputs = {};

            action.payload.inputParameters.forEach(function (inputParameter) {
                nextInputs[uuidV4()] = {
                    id: inputParameter.Id,
                    name: inputParameter.ParameterName,
                    value: inputParameter.ParameterValue,
                    pendingServerDeletion: false
                };
            });

            var nextState = (0, _extends8.default)({}, state, {
                inputs: nextInputs
            });
            return nextState;

        case SAVE_CONFIGURATION.FAILURE:
            {
                console.log('Reducer: SAVE_CONFIGURATION.FAILURE');
                return state;
            }

        default:
            return state;
    }
}

/* action creators */
var deleteQuotesOnSendActive = exports.deleteQuotesOnSendActive = function deleteQuotesOnSendActive(active) {
    return {
        type: ACTIVE,
        payload: { active: active }
    };
};

var toggleDeleteQuotesOnSend = exports.toggleDeleteQuotesOnSend = function toggleDeleteQuotesOnSend() {
    return {
        type: TOGGLE_DELETE_ON_SEND
    };
};

var toggleDeleteAll = exports.toggleDeleteAll = function toggleDeleteAll() {
    return {
        type: TOGGLE_DELETE_ALL
    };
};

var toggleDeleteSelected = exports.toggleDeleteSelected = function toggleDeleteSelected() {
    return {
        type: TOGGLE_DELETE_SELECTED
    };
};

var toggleSendEmail = exports.toggleSendEmail = function toggleSendEmail() {
    return {
        type: TOGGLE_SEND_EMAIL
    };
};

var toggleSendCommand = exports.toggleSendCommand = function toggleSendCommand() {
    return {
        type: TOGGLE_SEND_COMMAND
    };
};

var toggleCached = exports.toggleCached = function toggleCached() {
    return {
        type: TOGGLE_CACHED
    };
};

var setSendCommand = exports.setSendCommand = function setSendCommand(value) {
    return {
        type: SET_SEND_COMMAND,
        payload: value
    };
};

var togglePushQuotes = exports.togglePushQuotes = function togglePushQuotes() {
    return {
        type: TOGGLE_PUSH_QUOTES
    };
};

var deleteQuotesOnSendValue = exports.deleteQuotesOnSendValue = function deleteQuotesOnSendValue(value) {
    return {
        type: VALUE,
        payload: value
    };
};

var wsdlLoading = exports.wsdlLoading = function wsdlLoading() {
    return {
        type: WSDL_LOADING
    };
};
var wsdlReadError = exports.wsdlReadError = function wsdlReadError(err) {
    return {
        type: WSDL_READ_ERROR,
        payload: err
    };
};
var wsdlParseError = exports.wsdlParseError = function wsdlParseError(err) {
    return {
        type: WSDL_PARSE_ERROR,
        payload: err
    };
};
var wsdlInvalidError = exports.wsdlInvalidError = function wsdlInvalidError(err) {
    return {
        type: WSDL_INVALID_ERROR,
        payload: err
    };
};

// for list of wsdl file parameters, see initialState.pushRefNum.wsdlFile.data
var wsdlSuccess = function wsdlSuccess(_ref) {
    var parameters = (0, _objectWithoutProperties3.default)(_ref, []);
    return {
        type: WSDL_SUCCESS,
        payload: (0, _extends8.default)({}, parameters)
    };
};

exports.wsdlSuccess = wsdlSuccess;
var createInput = exports.createInput = function createInput() {
    return {
        type: CREATE_INPUT
    };
};

var updateInput = exports.updateInput = function updateInput(id, name, value) {
    return {
        type: UPDATE_INPUT,
        payload: { id: id, name: name, value: value }
    };
};

var updateInputName = exports.updateInputName = function updateInputName(id, name) {
    return {
        type: UPDATE_INPUT_NAME,
        payload: { id: id, name: name }
    };
};

var updateInputValue = exports.updateInputValue = function updateInputValue(id, value) {
    return {
        type: UPDATE_INPUT_VALUE,
        payload: { id: id, value: value }
    };
};

var webMethod = exports.webMethod = function webMethod(m) {
    return {
        type: WEB_METHOD,
        payload: m
    };
};

var soapVersion = exports.soapVersion = function soapVersion(v) {
    return {
        type: SOAP_VERSION,
        payload: v
    };
};

var getConfiguration = exports.getConfiguration = {
    base: function base(codedToken) {
        return {
            type: GET_CONFIGURATION.BASE,
            url: 'webservice-settings/get-webservice-settings',
            token: codedToken
        };
    },
    request: function request() {
        return { type: GET_CONFIGURATION.REQUEST };
    },
    success: function success(configuration) {
        return { type: GET_CONFIGURATION.SUCCESS, payload: configuration };
    },
    failure: function failure(error) {
        return { type: GET_CONFIGURATION.FAILURE, error: error };
    }
};

var saveConfiguration = exports.saveConfiguration = {
    base: function base(configuration, codedToken) {
        return {
            type: SAVE_CONFIGURATION.BASE,
            url: 'webservice-settings/save-webservice-settings',
            data: configuration,
            token: codedToken
        };
    },
    request: function request() {
        return { type: SAVE_CONFIGURATION.REQUEST };
    },
    success: function success(configuration) {
        return { type: SAVE_CONFIGURATION.SUCCESS, payload: configuration };
    },
    failure: function failure(error) {
        return { type: SAVE_CONFIGURATION.FAILURE, error: error };
    }
};

var deleteInputReal = exports.deleteInputReal = function deleteInputReal(id) {
    return {
        type: DELETE_INPUT_REAL,
        payload: id
    };
};

var deleteInputUI = exports.deleteInputUI = function deleteInputUI(id) {
    return {
        type: DELETE_INPUT_UI,
        payload: id
    };
};

var deleteInputDB = exports.deleteInputDB = {
    base: function base(clientId, serverId, codedToken) {
        return {
            id: clientId,
            token: codedToken,
            serverId: serverId,
            type: DELETE_INPUT.BASE,
            url: 'webservice-settings/delete-webservice-inputparameter'
        };
    },
    request: function request() {
        return { type: DELETE_INPUT.REQUEST };
    },
    success: function success(id) {
        return { type: DELETE_INPUT.SUCCESS, payload: id };
    },
    failure: function failure(error) {
        return { type: DELETE_INPUT.FAILURE, error: error };
    }
};

/* sagas */
function saveConfigurationSaga(_ref2) {
    var url = _ref2.url,
        data = _ref2.data,
        token = _ref2.token;
    var apiData, body, result;
    return _regenerator2.default.wrap(function saveConfigurationSaga$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    // format data for API
                    apiData = {
                        WsdlConnectionId: 0,
                        wsdlConnection: {
                            // "WsdlFileName": "",
                            // "WsdlFileContent": null,
                            WebServiceURL: data.pushRefNum.wsdlFile.data.url,
                            WebMethod: data.pushRefNum.wsdlFile.webMethod,
                            Namespace: data.pushRefNum.wsdlFile.data.namespace,
                            SOAPNamespace: data.pushRefNum.wsdlFile.data.soapNamespace,
                            Cached: data.pushRefNum.wsdlFile.cached,
                            RequestObjectName: data.pushRefNum.wsdlFile.data.xmlRequestMainNode,
                            RequestObjectNamespace: data.pushRefNum.wsdlFile.data.xmlRequestNamespace,
                            // "ResponseNodeName": "GetReferenceNumberResponse",
                            // "ResponseTextName": null,
                            // "ResponseValueName": null,
                            // "RowOrder": null,


                            // "ProductIdFky": 2,
                            ReplicationServiceId: data.pushRefNum.wsdlFile.replicationServiceId,
                            Id: data.pushRefNum.wsdlFile.id
                        },
                        // inputParameters: [
                        //   {
                        //     "ParameterName": "FOO",
                        //     "ParameterValue": "BAR",
                        //     "RowOrder": 0,
                        //     "ParameterType": "Input",
                        //     "WsdlConnectionIdFky": 0,
                        //     "ReplicationServiceId": data.pushRefNum.wsdlFile.replicationServiceId,
                        //     "Id": 0
                        //   }
                        // ]
                        inputParameters: (0, _keys2.default)(data.inputs).map(function (id) {
                            var current = data.inputs[id];
                            return {
                                ParameterName: current.name,
                                ParameterValue: current.value,
                                ParameterType: 'Input',
                                WsdlConnectionIdFky: data.pushRefNum.wsdlFile.id,
                                ReplicationServiceId: data.pushRefNum.wsdlFile.replicationServiceId,
                                Id: current.id
                            };
                        })
                    };
                    body = {
                        wsdlConnectionSettings: (0, _stringify2.default)(apiData)
                    };
                    _context.prev = 2;
                    _context.next = 5;
                    return (0, _effects.call)(function () {
                        return (0, _fetchEntitySagaAuth2.default)(saveConfiguration, _api2.default.post, url, { data: body, token: token });
                    });

                case 5:
                    result = _context.sent;
                    _context.next = 8;
                    return (0, _effects.put)((0, _notifications.success)({
                        title: 'Success',
                        message: 'Configuration has been saved correctly'
                    }));

                case 8:
                    return _context.abrupt('return', result);

                case 11:
                    _context.prev = 11;
                    _context.t0 = _context['catch'](2);
                    _context.next = 15;
                    return (0, _effects.put)((0, _notifications.error)({
                        title: 'Error saving configuration settings',
                        message: _context.t0.message
                    }));

                case 15:
                    return _context.abrupt('return', _context.t0);

                case 16:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[2, 11]]);
}

function deleteInputSaga(action) {
    var id, state, token, inputs;
    return _regenerator2.default.wrap(function deleteInputSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    id = action.payload;
                    _context2.next = 3;
                    return (0, _effects.select)();

                case 3:
                    state = _context2.sent;
                    token = state.auth.codedToken;
                    inputs = state.genericSettings.oldCFA.inputs;

                    if (!(inputs[id].id === '0')) {
                        _context2.next = 11;
                        break;
                    }

                    _context2.next = 9;
                    return (0, _effects.put)(deleteInputReal(id));

                case 9:
                    _context2.next = 13;
                    break;

                case 11:
                    _context2.next = 13;
                    return (0, _effects.put)(deleteInputDB.base(id, inputs[id].id, token));

                case 13:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function deleteInputDBSaga(_ref3) {
    var url = _ref3.url,
        token = _ref3.token,
        serverId = _ref3.serverId,
        id = _ref3.id;
    var data, result;
    return _regenerator2.default.wrap(function deleteInputDBSaga$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    data = { id: serverId };
                    _context3.prev = 1;
                    _context3.next = 4;
                    return (0, _effects.call)(function () {
                        return (0, _fetchEntitySagaAuth2.default)(deleteInputDB, _api2.default.post, url, { data: data, token: token });
                    });

                case 4:
                    result = _context3.sent;
                    _context3.next = 7;
                    return (0, _effects.put)(deleteInputReal(id));

                case 7:
                    return _context3.abrupt('return', result);

                case 10:
                    _context3.prev = 10;
                    _context3.t0 = _context3['catch'](1);
                    _context3.next = 14;
                    return (0, _effects.put)(deleteInputDB.failure(_context3.t0));

                case 14:
                    _context3.next = 16;
                    return (0, _effects.put)((0, _notifications.error)({
                        title: 'Error deleting parameter',
                        message: _context3.t0.message
                    }));

                case 16:
                    console.error(_context3.t0);

                case 17:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[1, 10]]);
}

function watchSaveConfiguration() {
    return _regenerator2.default.wrap(function watchSaveConfiguration$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _reduxSaga.takeLatest)(SAVE_CONFIGURATION.BASE, saveConfigurationSaga);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function oldCFAwatchers() {
    return _regenerator2.default.wrap(function oldCFAwatchers$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _reduxSaga.takeEvery)(DELETE_INPUT_UI, deleteInputSaga);

                case 2:
                    _context5.next = 4;
                    return (0, _reduxSaga.takeEvery)(DELETE_INPUT.BASE, deleteInputDBSaga);

                case 4:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/GenericSettings/oldCFA.js
// module id = 351
// module chunks = 0